import { render, staticRenderFns } from "./ProductDashboardHeader.vue?vue&type=template&id=49ca2738"
import script from "./ProductDashboardHeader.vue?vue&type=script&lang=js"
export * from "./ProductDashboardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports